import { Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormGroupDirective } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule  } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { Authenticate } from '../../models/authenticate';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../../services/login/login.service';


@Component({
  selector: 'app-deficiency-login',
  templateUrl: './deficiency-login.html',
  styleUrls: ['./deficiency-login.css'],
  imports: [ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class DeficiencyLogin implements OnInit {
  // Used to clear validation error states on Material form controls
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;

  loginInformation: FormGroup;
  authenticate: any;
  message: '';
  submitted = false;
  clicked = false;
  tempVar: number;
  showDivHasFiled: boolean = false;

  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
    private toastr: ToastrService,
    private _router: Router,
    private storage: LocalStorageService,
    private spinner: NgxSpinnerService,

  ) { }

  ngOnInit() {
    this.loginInformation = this.fb.group({
      claimNumber: ["", Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(9), Validators.pattern("^[0-9]+$")])]
    })
  }

  

  // convenience getter for easy access to form fields
  get f() { return this.loginInformation.controls; }

  onBlur(event) {
    if (event.target.value !== '')
      event.target.value = parseFloat(event.target.value).toFixed(2)
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginInformation.invalid) {
      this.clicked = false;
      return;
    }

    this.clicked = true;
    const au = this.loginInformation.value;

    this.spinner.show();

    this.Login(au);
  }


  Login(au: Authenticate) {
    this.loginService.login(au).subscribe({
      next: (res) => {
        this.authenticate = res;

        if (this.authenticate.hasFiled === false) {
          this.storage.store('authenticatedUser', this.authenticate);
          this._router.navigate(['/ltmdoc']);
        }
        else if (this.authenticate.hasFiled === true) {
          this.showDivHasFiled = true;

          this.toastr.error('You have already submitted your documents', 'Info Already Saved', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        }

        // cleanup
        this.spinner.hide();
        this.clicked = false;
        this.loginInformation.reset();
        this.loginInformation.get('claimNumber').clearValidators();
        this.loginInformation.get('claimNumber').updateValueAndValidity();

      },

      error: (err) => {
        if (err.status === 404) {
          this.toastr.error('User not found', 'Error', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        } else {
          this.toastr.error('Something went wrong, Please Check Again', 'Error', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        }

        this.spinner.hide();
        this.clicked = false;
        this.loginInformation.reset();
      }
    });
  }
}
